
// src/actions/translate.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const TRANSLATE_DIARY = "TRANSLATE_DIARY"
export const TRANSLATE_DIARY_REQUESTED = "TRANSLATE_DIARY_REQUESTED"
export const TRANSLATE_DIARY_COMPLETED = "TRANSLATE_DIARY_COMPLETED"
export const TRANSLATE_DIARY_FAILED = "TRANSLATE_DIARY_FAILED"

export function translateDiaryRequested(group_id, diary_id) {
  return {
    type: TRANSLATE_DIARY_REQUESTED,
    group_id, diary_id
  }
}

export function translateDiary(group_id, diary_id, lang = undefined) {
  return function(dispatch) {
    dispatch(translateDiaryRequested(group_id, diary_id))
    return api.get(`/translate/diaries/${diary_id}`, { lang })
        .then((results)=> {
          dispatch(translateDiaryCompleted(group_id, diary_id, results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(translateDiaryFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function translateDiaryCompleted(group_id, diary_id, results) {
  return {
    type: TRANSLATE_DIARY_COMPLETED,
    group_id, diary_id, results,
  }
}

export function translateDiaryFailed(error) {
  return {
    type: TRANSLATE_DIARY_FAILED,
    error,
  }
}

export const TRANSLATE_COMMENT = "TRANSLATE_COMMENT"
export const TRANSLATE_COMMENT_REQUESTED = "TRANSLATE_COMMENT_REQUESTED"
export const TRANSLATE_COMMENT_COMPLETED = "TRANSLATE_COMMENT_COMPLETED"
export const TRANSLATE_COMMENT_FAILED = "TRANSLATE_COMMENT_FAILED"

export function translateCommentRequested(group_id, diary_id, comment_id) {
  return {
    type: TRANSLATE_COMMENT_REQUESTED,
    group_id, diary_id, comment_id,
  }
}

export function translateComment(group_id, diary_id, comment_id, lang = undefined) {
  return function(dispatch) {
    dispatch(translateCommentRequested(group_id, diary_id, comment_id))
    return api.get(`/translate/comments/${comment_id}`, { lang })
        .then((results)=> {
          dispatch(translateCommentCompleted(group_id, diary_id, comment_id, results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(translateCommentFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function translateCommentCompleted(group_id, diary_id, comment_id, results) {
  return {
    type: TRANSLATE_COMMENT_COMPLETED,
    group_id, diary_id, comment_id, results,
  }
}

export function translateCommentFailed(error) {
  return {
    type: TRANSLATE_COMMENT_FAILED,
    error,
  }
}

export const TRANSLATE_MESSAGE = "TRANSLATE_MESSAGE"
export const TRANSLATE_MESSAGE_REQUESTED = "TRANSLATE_MESSAGE_REQUESTED"
export const TRANSLATE_MESSAGE_COMPLETED = "TRANSLATE_MESSAGE_COMPLETED"
export const TRANSLATE_MESSAGE_FAILED = "TRANSLATE_MESSAGE_FAILED"

export function translateMessageRequested(chat_room_id, message_id) {
  return {
    type: TRANSLATE_MESSAGE_REQUESTED,
    chat_room_id, message_id,
  }
}

export function translateMessage(chat_room_id, message_id, lang = undefined) {
  return function(dispatch) {
    dispatch(translateMessageRequested(chat_room_id, message_id))
    return api.get(`/translate/chat_messages/${message_id}`, { lang })
        .then((results)=> {
          dispatch(translateMessageCompleted(chat_room_id, message_id, results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(translateMessageFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function translateMessageCompleted(chat_room_id, message_id, results) {
  return {
    type: TRANSLATE_MESSAGE_COMPLETED,
    chat_room_id, message_id, results,
  }
}

export function translateMessageFailed(error) {
  return {
    type: TRANSLATE_MESSAGE_FAILED,
    error,
  }
}



// WEBPACK FOOTER //
// ./src/actions/translate.js